import { API_PDC_URL_V2 } from "../../../../config";
import { createHttpHeaderWithAuthorization } from "../../../services/http-header";
import { callWithRetry } from "../../../services/callWithRetry";
export const tableBodyConstants = {
  SEND_NOTIFY_V2_START: "SEND_NOTIFY_V2_START",
  SEND_NOTIFY_V2_SUCCESS: "SEND_NOTIFY_V2_SUCCESS",
  SEND_NOTIFY_V2_ERROR: "SEND_NOTIFY_V2_ERROR"
};

export function sendNotify(deadlineId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise(function(resolve, reject) {
      dispatch({
        type: tableBodyConstants.SEND_NOTIFY_V2_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/deadlines/${deadlineId}/remind`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(() => {
          dispatch({
            type: tableBodyConstants.SEND_NOTIFY_V2_SUCCESS
          });
          resolve();
        })
        .catch(err => {
          dispatch({
            type: tableBodyConstants.SEND_NOTIFY_V2_ERROR,
            error: err.toString()
          });
          reject();
        });
    });
  };
}
